import { ServiceHandler } from '../../../../../utils';
import {
  Agreement,
  Cart,
  CreateCartLineItemRequest,
  CreateCartRequest,
  Invoice,
  UpdateCartLineItemRequest,
  UpdateCartRequest,
} from '../types/types';

const resilienceBasePath = '/api/resilience';
const basePath = `${resilienceBasePath}/v1/carts`;

export const getCart = ServiceHandler<unknown, Cart>({
  url: `${basePath}/my`,
  method: 'GET',
});

export const createCart = ServiceHandler<CreateCartRequest, Cart>({
  url: `${basePath}`,
  method: 'POST',
});

export const updateCart = ServiceHandler<UpdateCartRequest, Cart>({
  url: `${basePath}`,
  method: 'PUT',
});

export const addCartLineItemToCart = ServiceHandler<
  CreateCartLineItemRequest,
  Cart
>({
  url: `${basePath}/items`,
  method: 'POST',
});

export const updateCartLineItem = ServiceHandler<
  UpdateCartLineItemRequest,
  Cart
>({ url: `${basePath}/items/:cartLineItemId`, method: 'PATCH' });

export const deleteCartLineItem = ServiceHandler<unknown, Cart>({
  url: `${basePath}/items/:cartLineItemId`,
  method: 'DELETE',
});

export const checkoutCart = ServiceHandler({
  url: `${basePath}/checkout`,
  method: 'POST',
});

export const checkoutActivityLog = ServiceHandler({
  url: `${basePath}/checkout/activity-log`,
  method: 'POST',
});

export const getInvoices = ServiceHandler<unknown, Invoice[]>({
  url: `${resilienceBasePath}/v1/invoices`,
  method: 'GET',
});

export const getInvoiceByCartId = ServiceHandler<unknown, Invoice>({
  url: `${resilienceBasePath}/v1/invoices/cart/:cartId`,
  method: 'GET',
});

export const createAgreements = ServiceHandler({
  url: `${resilienceBasePath}/v1/agreements`,
  method: 'POST',
});

export const getAgreements = ServiceHandler<unknown, Agreement[]>({
  url: `${resilienceBasePath}/v1/agreements`,
  method: 'GET',
});

export const getAgreementsOfCurrentCart = ServiceHandler<void, Agreement[]>({
  url: `${resilienceBasePath}/v1/agreements/current-cart`,
  method: 'GET',
});

export const signAgreement = ServiceHandler({
  url: `${resilienceBasePath}/v1/agreements/:agreementId`,
  method: 'PUT',
});
